var map = {
	"./aqua.png": 795,
	"./aqua@2x.png": 72197,
	"./aqua@3x.png": 77658,
	"./blue.png": 21727,
	"./blue@2x.png": 6193,
	"./blue@3x.png": 25734,
	"./cyan.png": 7662,
	"./cyan@2x.png": 64998,
	"./cyan@3x.png": 15729,
	"./darkMagenta.png": 64554,
	"./darkMagenta@2x.png": 86234,
	"./darkMagenta@3x.png": 21893,
	"./darkOrange.png": 49649,
	"./darkOrange@2x.png": 42163,
	"./darkOrange@3x.png": 60968,
	"./darkRed.png": 56826,
	"./darkRed@2x.png": 49738,
	"./darkRed@3x.png": 19637,
	"./deepPink.png": 47133,
	"./deepPink@2x.png": 79303,
	"./deepPink@3x.png": 24156,
	"./forestGreen.png": 83723,
	"./forestGreen@2x.png": 5013,
	"./forestGreen@3x.png": 35114,
	"./gold.png": 68713,
	"./gold@2x.png": 65451,
	"./gold@3x.png": 60576,
	"./greenSea.png": 28693,
	"./greenSea@2x.png": 65471,
	"./greenSea@3x.png": 16276,
	"./magenta.png": 61046,
	"./magenta@2x.png": 270,
	"./magenta@3x.png": 35097,
	"./orange.png": 33741,
	"./orange@2x.png": 87927,
	"./orange@3x.png": 61164,
	"./pink.png": 81631,
	"./pink@2x.png": 43153,
	"./pink@3x.png": 18278,
	"./red.png": 46238,
	"./red@2x.png": 67254,
	"./red@3x.png": 71681,
	"./residence.png": 35115,
	"./residence@2x.png": 91637,
	"./residence@3x.png": 26186,
	"./skyBlue.png": 24092,
	"./skyBlue@2x.png": 73004,
	"./skyBlue@3x.png": 99767,
	"./yellowGreen.png": 82330,
	"./yellowGreen@2x.png": 16682,
	"./yellowGreen@3x.png": 82133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92535;